/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import { Grid, Box, Typography, Avatar, Button } from "@mui/material";
import Loading from "../../components/loading/loading";
// import "./Verify.css";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import { Wrapper } from "../../components/NDID2";
import { address, config } from "../../constants";

import { isMobile } from "react-device-detect";
import BannerContentLeft from "../../components/BannerContentLeft/BannerContentLeft";
import ButtonCustom from "../../components/button/ButtonCustom";
import { checkDipChipStatus } from "../../components/helpers/api";
import DIPCHIP_ICON from "./DIPCHIP_icon.png";
import DAOL_ICON from "./daol_icon.png";

const _url = config.baseAPIURL03;

class VerifyWaiting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      BankID: localStorage.getItem("BankID"),
      BankLogo: localStorage.getItem("BankImage"),
      ApplicationName: localStorage.getItem("BankName"),
      NDID_Status: "LOADING",
      NDID_Status_Display: "LOADING",
      NDIDRequestId: "",
      ReferenceId: "",
      TransactionRef: "",
      RequestMessage: "",
      isStopped: false,
      isPaused: false,
      loading: false,
      isCancel: false,
      cancelled_by_user: false,
      ErrorMessage: "",
      countDown: null,
    };
    this.goBack = this.goBack.bind(this);
    // localStorage.removeItem('HeaderManp');
  }

  goBack() {
   
    this.props.history.goBack();
  }

  allStorage() {
    var values = [],
      keys = Object.keys(localStorage),
      i = keys.length;
    while (i--) {
      if (keys[i].indexOf("debug") !== -1) {
      } else {
        values.push({
          key: keys[i],
          value: localStorage.getItem(keys[i]),
        });
      }
    }
    return values;
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async componentDidMount() {

  }

  componentWillUnmount() {

  }
  popup = (msg, title = "เกิดข้อผิดพลาด", func, buttonText = "ตกลง") => {
    const MySwal = withReactContent(swal);
    MySwal.fire({
      customClass: {
        confirmButton: "long_btn_fix",
        cancelButton: "long_btn_fix",
      },
      // icon: 'warning',
      // imageUrl: "/images/ico_alert.svg",
      imageWidth: 100,
      imageHeight: 100,
      confirmButtonColor: "#003b66",
      confirmButtonText: buttonText,
      title: `<span class="title_popup">${title}</span>`,
      html: `<div class="content_popup">${msg}</div>`,
    }).then(
      func ||
      function () {
        // vm.handleCheckTotalOfNDID('');
      }
    );
  };

  passDIPCHIP = async (msg) => {
    const MySwal = withReactContent(swal);
    const vm = this;
    MySwal.fire({
      customClass: {
        confirmButton: "long_btn_fix",
        cancelButton: "long_btn_fix",
      },
      imageUrl: "/images/ico_approve.svg",
      imageWidth: 100,
      imageHeight: 100,
      confirmButtonColor: "#003b66",
      confirmButtonText: "ถัดไป",
      title: `<span class="title_popup">${msg}</span>`,
    }).then(async function () {
      vm.setState({ loading: true });
      var last_stamp = await JSON.stringify(vm.allStorage());
      const HeaderManp = JSON.parse(localStorage.getItem("HeaderManp"));
      const head_token = HeaderManp.head_token;
      const token = HeaderManp.head_token;
      const ops = {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Accept: "application/json",
        },
        data: {
          last_stamp: last_stamp,
          head_token: head_token,
          stamp_page: "DIPCHIP",
        },
        url: _url + "/form/comeback/manp",
      };
      axios(ops)
        .then(async (res) => {
          vm.setState({ loading: false });
          vm.props.history.push("/idc_address_choose");
        })
        .catch((error) => {
          vm.setState({ loading: false });
          vm.notPassNDID(
            "สอบถามข้อมูลเพิ่มเติมกรุณาติดต่อ DAOL Contact Center<br>0 2351 1800",
            "ไม่สามารถทำรายการได้"
          );
        });
    });
  };

  handleNext = async () => {
    this.setState({ loading: true })
    try {
      const HeaderManp = JSON.parse(localStorage.getItem("HeaderManp"));
      let checkuserinfo = JSON.parse(localStorage.getItem("checkuserinfo"))
      const status = await checkDipChipStatus(HeaderManp.head_token, checkuserinfo)
      if (status === true) {
        localStorage.setItem("pass_dipchip", true);
        this.passDIPCHIP("การยืนยันตัวตนสำเร็จ");
      } else {
        const ic = JSON.parse(localStorage.getItem("current_ic"))
        const ICTel = ic.ICTel ? `กด 0 ต่อ ${ic.ICTel}` : "";
        const icText = `${ic.AECode} - ${ic.ICName} <br>เบอร์โทร : 0 2351 1800 ${ICTel}`
        let mssDes = `
         <p style="background-color: rgb(247, 248, 251);padding: 10px;"> ${icText}
         <br>เพื่อดำเนินการยืนยันตัวตนด้วยการ Dip Chip 
        </p>
        <p>
        หากท่านต้องการเปลี่ยนช่องทางการยืนยันตัวตน <br>ท่านสามารถกดย้อนกลับ เพื่อเลือกช่องทางการยืนยันตัวตน อื่นๆ ได้
        <br>หรือติดต่อ DAOL Contact Center 0 2351 1800 เพื่อสอบถามข้อมูลเพิ่มเติม
        </p>
       `
        let title = "กรุณาติดต่อเจ้าหน้าที่แนะนำการลงทุน  <br> เพื่อเสียบบัตรประชาชน (Dip Chip)";
        this.popup(mssDes, title)
      }
      this.setState({ loading: false })
    } catch (error) {
      this.setState({ loading: false })
    }


  };
  render() {
    return (
      <div className={isMobile ? "" : "body"}>
        <Loading status={this.state.loading} />
        <header
          className={isMobile ? "" : "header-area"}
          style={{ display: isMobile ? "none" : "block" }}
        >
          <div className={"container everest-nav-container"}>
            <div className={"row"}>
              <div className={"col-md-6"}>
                <img src="../../../images/logo.png" />
              </div>
              <div className={"col-md-6 flex_end"}>
                <div className="text-branding">บริการเปิดบัญชีออนไลน์</div>
              </div>
            </div>
          </div>
        </header>
        <section
          className={isMobile ? "" : "desktop_content section-gap-full"}
          style={{
            backgroundImage: isMobile ? "none" : "url(/images/bg.jpg)",
          }}
        >
          <div className={isMobile ? "" : "container"}>
            <div className={isMobile ? "" : "row"}>
              <div
                className={"col-md-6"}
                style={{ display: isMobile ? "none" : "block" }}
              >
                <BannerContentLeft></BannerContentLeft>
              </div>
              <div className={isMobile ? "" : "col-md-6"}>
                {/* content mobile */}
                <div>
                  <div className="content">
                    <div className="top_main_back">
                      <div className="main_back" onClick={this.goBack}>
                        <img
                          src={
                            isMobile
                              ? "/images/angle-arrow-left.svg"
                              : "/images/angle-arrow-left-blue.svg"
                          }
                          style={{ marginLeft: "3px" }}
                          className="arrow_back"
                        />
                      </div>
                      <div className="text_title">
                        ยืนยันตัวตนทาง DIPCHIP
                      </div>
                    </div>

                    <div
                      className="bg_content_white over_f_hide"
                      style={{ padding: "3" }}
                    >
                      <div
                        className="in_bg_white autoscroll"
                        style={{ top: 0, left: 0, right: 0 }}
                      >
                        <Wrapper
                          content={
                            <Grid id="DIPCHIP-steps" container>
                              <Grid
                                sx={{ marginBottom: "16px", width: "100%" }}
                              >
                                <Typography
                                  className="text-primary"
                                  sx={{
                                    fontFamily: "DB Heavent Med !important",
                                    fontSize: "22px",
                                    lineHeight: "26px",
                                    textAlign: "center",
                                  }}
                                >
                                  ขั้นตอนการยืนยันตัวตน
                                </Typography>
                              </Grid>

                              {/* ------- DIPCHIP Step 2 -------  */}
                              <Box
                                id="DIPCHIP-step-1"
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              >
                                <Box
                                  id="step-img"
                                  sx={{
                                    marginRight: "16px",
                                    padding: "11px",
                                    backgroundColor: "#F7F8FB",
                                    borderRadius: "10px",
                                    width: "48px",
                                    height: "48px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Avatar
                                    alt="DIPCHIP-logo"
                                    src={DIPCHIP_ICON}
                                    variant="rounded"

                                    sx={{ width: 48, height: "auto" }}
                                  // sx={{ width: 48, height: 26 }}
                                  />
                                </Box>
                                <Box id="step-description">
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-18 text-primary"
                                      sx={{ lineHeight: "22px" }}
                                    >
                                      ขั้นตอนที่ 1
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-20 text-black"
                                      sx={{ lineHeight: "24px" }}
                                    >
                                      ติดต่อผู้ดูแลการลงทุนเพื่อดำเนินการนัดหมายวันเข้าทำการ {" "}
                                      <Typography
                                        className="font-DBHeavent font-20"
                                        sx={{
                                          color: "#AA875E",
                                          lineHeight: "24px",

                                        }}
                                        variant="span"
                                      >
                                        “DIPCHIP”
                                      </Typography>{" "}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>

                              {/* ------- DIPCHIP Step 2 -------  */}
                              <Box
                                id="DIPCHIP-step-2"
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <Box
                                  id="step-img"
                                  sx={{
                                    marginRight: "16px",
                                    padding: "11px",
                                    backgroundColor: "#F7F8FB",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    width: "48px",
                                    height: "48px",
                                  }}
                                >
                                  <Avatar
                                    alt="daolife-icon"
                                    src={DAOL_ICON}
                                    variant="rounded"
                                    sx={{ width: 48, height: 12 }}
                                  />
                                </Box>
                                <Box id="step-description">
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-18 text-primary"
                                      sx={{ lineHeight: "22px" }}
                                    >
                                      ขั้นตอนที่ 2
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-20 text-black"
                                      sx={{ lineHeight: "24px" }}
                                    >
                                      หลังจากทำการนัดหมายและทำการ  {" "}
                                      <Typography
                                        className="font-DBHeavent font-20"
                                        sx={{
                                          color: "#AA875E",
                                          lineHeight: "24px",
                                        }}
                                        variant="span"
                                      >
                                        “DIPCHIP”
                                      </Typography>{" "}
                                      เรียบร้อยแล้ว ท่านสามารถกลับมายังระบบเปิดบัญชี DAOL Investment เพื่อดำเนินการเปิดบัญชีต่อ
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                          }
                        />

                      </div>
                      <div className="under_fix_btn">
                        <span
                          className="font-DBHeavent font-16 font-weight-bold"
                          style={{ color: "red", marginBottom: "10px" }}
                        >
                          หากทำการยืนยันตัวตนผ่านวิธีการ DIPCHIP เรียบร้อยแล้ว กรุณากดปุ่ม “ดำเนินการต่อ” เพื่อไปยังขั้นตอนถัดไป
                        </span>
                        <ButtonCustom
                          handle={
                            this.handleNext
                          }
                          label="ดำเนินการต่อ"
                          color={"blue"}
                          btnClass="long_btn"
                        />
                      </div>

                    </div>
                  </div>
                </div>
                {/* end content mobile */}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default VerifyWaiting;
